import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { tableStyles } from "../PDFTable";
import { styles } from "./PDFLayerMeta/PDFLayerMeta.styles";

interface Field {
    label: string;
    display_vector: (size: number) => JSX.Element;
}

interface PDFTwoColumnMetaContentProps {
    fields: Field[];
}

export const PDFTwoColumnMetaContent = ({ fields }: PDFTwoColumnMetaContentProps) => {
    return (
        <>
            {fields.map((i, index) => (
                <View key={index} style={styles.metaItemsIntakeReport}>
                    <View>
                        <Text>{i.label}:</Text>
                    </View>

                    <View>
                        <Text style={styles.metaTextValueIntakeReport}>
                            {i.display_vector(9)}
                        </Text>
                    </View>
                </View>
            ))}
        </>
    );
};

interface PDFSingleColumnMetaProps extends PDFTwoColumnMetaContentProps {
    title: string;
}

export const PDFSingleColumnMeta: React.FC<PDFSingleColumnMetaProps> = ({ title, fields }) => {
    return (
        <View>
            <Text style={tableStyles.pageTitle}>{title}</Text>

            <View style={styles.container}>
                {fields.map((i, index) => (
                    <View key={index} style={styles.metaItemsIntakeReport}>
                        <View>
                            <Text>{i.label}:</Text>
                        </View>

                        <View>
                            <Text style={styles.metaTextValueIntakeReport}>
                                {i.display_vector(9)}
                            </Text>
                        </View>
                    </View>
                ))}
            </View>
        </View>
    );
};
